import React from 'react';
import styled from 'styled-components';

import { colorPalette } from '../../Config/colorConfig.js'

import { cardListIcon } from '../../Config/cardConfig.js'

import situationroomConfig from '../../data/situationroom.js'

const Img = styled.img`
    position:relative;
    display:flex;
    height:auto;
`

const Introduction1 = styled.ul`
    width:70%;
    max-width:750px;
    color: #000;
    padding:1rem 0rem;
    list-style-image: url(${cardListIcon});
    font-size:1rem;
    &>li{
        line-height:2rem;
        margin:1rem 0rem;
    }
`

const Introduction2Wrapper = styled.div`
    position:relative;
    width:50%;
    display:flex;
    flex-direction:${props => props.langCh?'row':'column'};
    justify-content:center;
    align-items:${props => props.langCh?'center':'flex-start'};
    margin-bottom:1rem;
    @media (max-width: 1000px) {
        flex-direction: column;
        width:70%;
    }
    @media (max-width: 768px) {
        width:90%;
    }
`

const Introductin2Col = styled.div`
    position:relative;
    padding:0rem 2rem;
    display:flex;
    flex-direction:column;
`

const Introduction2Item = styled.div`
    position:relative;
    display:flex;
    flex-direction:row;
    align-items:flex-start;
    width:100%;
    font-size:1.2rem;
    margin:0px;//important!!
    padding:0px;
`

const SituationroomCard=(props)=>{
    
    const {langCh}=props

    return(
        <>
        <Img
            src={situationroomConfig[langCh?'ch':'en'].img1}
            style={{width:'100%',maxWidth:'1000px',marginTop:'40px'}}
        />
        <Introduction1>
            {situationroomConfig[langCh?'ch':'en'].introduction1.map((data,i)=>
                <li key={i}>{data}</li>)
            }
        </Introduction1>
        <Introduction2Wrapper langCh={langCh}>
            <Introductin2Col>
                {situationroomConfig[langCh?'ch':'en'].introduction2[0].map((data,i)=>
                    <Introduction2Item key={i}>
                        <p style={{fontSize:'1.5rem'}}>{data[0]}</p>
                        <p style={{color:colorPalette.myBlue, paddingTop:'0.75rem'}}>{data[1]}</p>
                    </Introduction2Item>
                )
                }
            </Introductin2Col>
            <Introductin2Col>
                {situationroomConfig[langCh?'ch':'en'].introduction2[1].map((data,i)=>
                    <Introduction2Item key={i}>
                        <p style={{fontSize:'1.5rem'}}>{data[0]}</p>
                        <p style={{color:colorPalette.myBlue, paddingTop:'0.75rem'}}>{data[1]}</p>
                    </Introduction2Item>
                )
                }
            </Introductin2Col>
        </Introduction2Wrapper>
        <Img
            src={situationroomConfig[langCh?'ch':'en'].img2}
            style={{width:'70%',maxWidth:'800px',marginBottom:'40px'}}
        />
        </>
    )
}

export default SituationroomCard;